(function() {
  window.adConfigs = window.adConfigs || {};

  const flavours = ['Caramel', 'Peanut Butter', 'Pistachio', 'Raspberry', 'Hazelnut', 'Malt Cornflakes'];

  const mixedChips = flavours.map((f, i) =>
    `<span class="bb-flavour-chip">${f}</span>${i < flavours.length - 1 ? ' <span class="bb-sep">·</span> ' : ''}`
  ).join('');

  const descriptor = `<span style="color: #5b4637;"><strong>Six handmade filled chocolate bars</strong></span><br>${mixedChips}`;
  const cartSub = 'Six bars: ' + flavours.join(' · ');

  window.adConfigs['retargeting-worthit'] = {
    subline1: '<span style="font-size: 0.6em; letter-spacing: 2px;">★★★★★</span><br>"Worth every penny"',
    subline2: descriptor,
    cartSub:  cartSub,
    image:    'https://barnabybars.com/cdn/shop/files/Barnaby_Dec25-065.jpg?v=1774431167&width=1346',
    hideThumbnail2: true,
  };

  window.adConfigs['retargeting-bestchoc'] = {
    subline1: '<span style="font-size: 0.6em; letter-spacing: 2px;">★★★★★</span><br>"Best chocolate I\'ve ever had"',
    subline2: descriptor,
    cartSub:  cartSub,
    image:    'https://barnabybars.com/cdn/shop/files/Barnaby_Dec25-065.jpg?v=1774431167&width=1346',
    hideThumbnail2: true,
  };

})();